import {FunctionField} from "react-admin";

export function CoreTextFieldEllipseComponent({
    label,
    source,
    length,
    ...props
}) {
    return <FunctionField {...props}  label={label} source={source} render={rec => {
        if (rec[source]?.length > length) {
            return <span title={rec[source]}> {rec[source].substring(0, length - 1) + '...'} </span>
        }
        return rec[source];
    }}  />
}